import { PaymentInfo } from 'actions/actionTypes';

export const changeShopBillReceive = (name, value) => ({ type: PaymentInfo.CHANGE_SHOP_BILL_RECEIVE_INFO, payload: { name, value } });

export const loadShopBillReceiveInfoRequest = () => ({ type: PaymentInfo.LOAD_SHOP_BILL_RECEIVE_INFO_REQUEST });
export const loadShopBillReceiveInfoSuccess = (responseData) => ({ type: PaymentInfo.LOAD_SHOP_BILL_RECEIVE_INFO_SUCCESS, payload: responseData });
export const loadShopBillReceiveInfoFailure = (errorMessage) => ({ type: PaymentInfo.LOAD_SHOP_BILL_RECEIVE_INFO_FAILURE, payload: errorMessage });